"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["onFocus", "onBlur", "onMouseDown"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable react/static-property-placement */ /* eslint-disable react/state-in-constructor */ /* eslint-disable react/sort-comp */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable no-nested-ternary */
// TODO: convert to hooks (UICOMP-8905)
// copied from https://github.com/ferdaber/react-focus-within/blob/master/src/index.js
// no updates since 2020, causing peerDep problems
var FocusWithin = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FocusWithin, _React$Component);
  var _super = _createSuper(FocusWithin);
  function FocusWithin() {
    var _context;
    var _this;
    (0, _classCallCheck2.default)(this, FocusWithin);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, _args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isBlurring: false,
      isFocused: false
    });
    // delay by one turn of the event loop, used to consolidate timing between
    // FocusWithin events and native events
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "delay", function (cb) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      return setTimeout(function () {
        if (_this.isUnmounted) {
          return;
        }
        cb.apply(void 0, args);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setFocusState", function (isFocused, isFocusWithinEvent) {
      var setStateCb = function setStateCb() {
        if (_this.isUnmounted) return;
        _this.setState(function (state) {
          return state.isFocused === isFocused ? state : !isFocused ? {
            isFocused: isFocused,
            isBlurring: true
          } : {
            isFocused: isFocused
          };
        });
      };
      // delay processing native events for one turn of the event loop
      // to have it be on the same timing as FocusWithin events
      if (isFocusWithinEvent) {
        setStateCb();
      } else {
        _this.delay(setStateCb);
      }
    });
    // track mouse activity within the FocusWithin container, which allows clicking inside it
    // whenever a mousedown occurs we save the current container element, and if on mouseup
    // we are outside the container, we emit the blur event appropriately
    // mouseups can still occur outside the container with actual DOM focus remaining within
    // so we do not emit blurs for those
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDocumentMouseUp", function (event) {
      var container = _this.mouseDownWithinTarget;
      var mouseUpWithinTarget = container && container.contains(event.target);
      var activeElementWithinTarget = container && container.contains(document.activeElement);
      if (!activeElementWithinTarget && !mouseUpWithinTarget) {
        _this.setFocusState(false, _this.lastBlurEvent ? _this.lastBlurEvent.__isFocusWithinEvent : true);
      }
      _this.mouseDownWithinTarget = null;
      _this.lastBlurEvent = null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFocusProps", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _onFocus = _ref.onFocus,
        _onBlur = _ref.onBlur,
        _onMouseDown = _ref.onMouseDown,
        props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
      return _objectSpread(_objectSpread({}, props), {}, {
        onFocus: function onFocus(event) {
          var propagationStopped = _onFocus && _onFocus(event) === false;
          if (propagationStopped || event && event.focusWithinDefaultPrevented) {
            return;
          }
          _this.setFocusState(true, event && event.__isFocusWithinEvent);
        },
        onBlur: function onBlur(event) {
          var propagationStopped = _onBlur && _onBlur(event) === false;
          if (propagationStopped || event && event.focusWithinDefaultPrevented) {
            return;
          }
          // if blur event happens right after a mousedown of an element inside
          // the FocusWithin container
          // we don't emit the blur event immediately and check if we should emit it
          // later after the mouseup occurs
          if (_this.mouseDownWithinTarget) {
            // eslint-disable-next-line no-unused-expressions
            event.persist && event.persist();
            _this.lastBlurEvent = event;
            return;
          }
          _this.setFocusState(false, event && event.__isFocusWithinEvent);
        },
        onMouseDown: function onMouseDown(event) {
          var propagationStopped = _onMouseDown && _onMouseDown(event) === false;
          if (propagationStopped || event && event.focusWithinDefaultPrevented) {
            return;
          }
          _this.mouseDownWithinTarget = event.currentTarget;
        }
      });
    });
    return _this;
  }
  (0, _createClass2.default)(FocusWithin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var _this2 = this;
      if (prevState.isFocused && !this.state.isFocused) {
        this.delay(function () {
          if (_this2.isUnmounted) {
            return;
          }
          _this2.setState({
            isBlurring: false
          });
          // check if the focus manager is actually blurred for times
          // when document click causes a consective blur -> focus
          if (!_this2.state.isFocused) {
            _this2.props.onBlur({
              __isFocusWithinEvent: true
            });
          }
        });
      }
      // check if the focus manager was focused from the outside
      // and not from another child element
      // delay onfocus emission to be on the same timing as blur events
      if (!this.state.isBlurring && !prevState.isFocused && this.state.isFocused) {
        this.delay(this.props.onFocus, {
          __isFocusWithinEvent: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounted = true;
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? this.props.children({
        focusProps: this.getFocusProps(),
        getFocusProps: this.getFocusProps,
        // stabilize isFocused so that it only changes corresponding to its event emissions
        isFocused: this.state.isFocused || this.state.isBlurring
      }) : null;
    }
  }]);
  return FocusWithin;
}(_react.default.Component);
(0, _defineProperty2.default)(FocusWithin, "propTypes", {
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func
});
(0, _defineProperty2.default)(FocusWithin, "defaultProps", {
  onBlur: function onBlur() {},
  onFocus: function onFocus() {}
});
var _default = FocusWithin;
exports.default = _default;